import Vue from 'vue'
import App from './App.vue'

import router from './utils/router'
import vuetify from './plugins/vuetify'
import store from './utils/store'
import './assets/app.css';

import Filter from './utils/Filter'
Filter.load(Vue);

new Vue({
  el: '#app',
  store,
  router,
  vuetify,
  render: h => h(App)
})
